import React, { Fragment, PureComponent } from 'react';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../components/layout/Grid';
import TextField from '../../components/form/TextField';
import Checkbox from '../../components/form/Checkbox';
import TimeSelect from '../../components/form/TimeSelect';
import StaffAllocationTable from '../../components/form/StaffAllocationTable';

class AllocationPopover extends PureComponent {
    render() {
        const { form } = this.props;
        const deceasedName = form.getField('Cremation.NameOfDeceased');

        return (
            <Fragment>
                <Grid container spacing={2}>
                    <StaffAllocationTable
                        form={form}
                        name="StaffAllocations"
                        allocationType="ReflectionRoom"
                        defaultDate="Date"
                        defaultTime="Time"
                        defaultDuration="Duration"
                    />

                    <Grid item>
                        <TextField label="Deceased name" readOnly value={deceasedName} />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="Date" type="date" form={form} name="Date" />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="Start time" type="time" form={form} name="Time" />
                    </Grid>
                    <Grid item xs={4}>
                        <TimeSelect label="Duration (hours)" form={form} name="Duration" useNumbers />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField label="Number of people" type="number" form={form}
                                   name="NumberOfPeople"
                                   InputLabelProps={{ shrink: true }}
                                   inputProps={{ min: 0 }} />
                    </Grid>
                    <Grid item xs={6}>
                        <Checkbox label="Confirmed" form={form} name="Confirmed" />
                    </Grid>

                    <Grid item>
                        <TextField label="Notes" multiline form={form} name="AttendeeNames" />
                    </Grid>

                </Grid>
            </Fragment>
        );
    }
}

export default withStyles({})(AllocationPopover);
